var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.examLoading,
          expression: "examLoading",
        },
      ],
      staticClass: "wrapper",
    },
    [
      _c("div", { staticClass: "menu-wrapper" }, [
        _c(
          "ul",
          { staticClass: "menu-list" },
          _vm._l(_vm.menus, function (item, index) {
            return _c(
              "li",
              {
                key: "menu-" + index,
                class: _vm.curMenuName === item.tabName ? "actived" : "",
                attrs: { "data-io-click": "tracker" },
                on: {
                  click: function ($event) {
                    return _vm.changeMenu(item)
                  },
                },
              },
              [
                _c(
                  "el-badge",
                  {
                    staticClass: "badge",
                    staticStyle: { "z-index": "10" },
                    attrs: { value: item.count, hidden: item.count <= 0 },
                  },
                  [_c("span", [_vm._v(_vm._s(item.permName))])]
                ),
              ],
              1
            )
          }),
          0
        ),
        _c(
          "div",
          { staticClass: "right-menu" },
          [
            _vm.curMenuName === "StudentAnswer"
              ? [
                  _vm.isReadWritePermission(2)
                    ? [
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "bottom",
                              width: "114",
                              trigger: "hover",
                              "popper-class": "student-answer",
                            },
                          },
                          [
                            _c("div", [
                              _c(
                                "ul",
                                _vm._l(_vm.moreMenus, function (item, index) {
                                  return _c(
                                    "li",
                                    {
                                      key: "export-" + index,
                                      staticClass: "menu-li",
                                      class:
                                        (item.menuIndex === 1 &&
                                          _vm.isReadWritePermission(3)) ||
                                        item.menuIndex !== 1
                                          ? ""
                                          : "disabled",
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeMoreMenu(item)
                                        },
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(item.permName) + " ")]
                                  )
                                }),
                                0
                              ),
                            ]),
                            _c(
                              "span",
                              {
                                staticClass: "button",
                                attrs: { slot: "reference" },
                                slot: "reference",
                              },
                              [_vm._v("更多设置")]
                            ),
                          ]
                        ),
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "bottom",
                              width: "114",
                              trigger: "hover",
                              "popper-class": "student-answer",
                            },
                          },
                          [
                            _c("div", [
                              _c(
                                "ul",
                                _vm._l(
                                  _vm.filteredExportMenus,
                                  function (item, index) {
                                    return _c(
                                      "li",
                                      {
                                        key: "export-" + index,
                                        staticClass: "menu-li",
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeExportMenu(item)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(item.permName) + " "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.$store.state.backDoor ||
                                      !(_vm.exam.isMore === 2),
                                    expression:
                                      "$store.state.backDoor || !(exam.isMore === 2)",
                                  },
                                ],
                                staticClass: "round-button",
                                attrs: { slot: "reference" },
                                slot: "reference",
                              },
                              [
                                _c("span", [_vm._v("导出")]),
                                _c("img", {
                                  staticStyle: { fill: "red" },
                                  attrs: { src: require("images/export.svg") },
                                }),
                              ]
                            ),
                          ]
                        ),
                      ]
                    : [
                        _c(
                          "span",
                          {
                            staticClass: "button",
                            staticStyle: { color: "#999999" },
                          },
                          [_vm._v("更多设置")]
                        ),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.$store.state.backDoor ||
                                  !(_vm.exam.isMore === 2),
                                expression:
                                  "$store.state.backDoor || !(exam.isMore === 2)",
                              },
                            ],
                            staticClass: "round-button round-button-disabled",
                          },
                          [
                            _c("span", [_vm._v("导出")]),
                            _c("img", {
                              staticStyle: { fill: "red" },
                              attrs: { src: require("images/export.svg") },
                            }),
                          ]
                        ),
                      ],
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
      _vm.showContent
        ? _c(
            "div",
            { staticClass: "content-wrapper" },
            [
              _c("header", { staticClass: "header-box" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "space-between",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "back",
                            on: { click: _vm.backAction },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("images/back.png"),
                                width: "10",
                              },
                            }),
                            _c("span", [_vm._v("返回")]),
                          ]
                        ),
                        _c("div", { staticClass: "exam-info" }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#919599",
                                "margin-right": "15px",
                              },
                            },
                            [_vm._v("|")]
                          ),
                          _vm.exam.subjectName
                            ? _c("div", { staticClass: "tool-subject" }, [
                                _c(
                                  "span",
                                  { staticStyle: { "margin-bottom": "5px" } },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.exam.subjectName.substr(0, 1))
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm.exam.examName
                            ? _c(
                                "span",
                                {
                                  staticClass: "exam-name",
                                  attrs: { title: _vm.exam.examName },
                                },
                                [_vm._v(_vm._s(_vm.exam.examName))]
                              )
                            : _vm._e(),
                          _c("img", {
                            staticStyle: { margin: "0 10px 0 20px" },
                            attrs: {
                              src: require("images/grade.png"),
                              width: "16",
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "14px",
                                color: "#606266",
                              },
                            },
                            [_vm._v("年级:")]
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "14px",
                                "margin-left": "4px",
                                color: "#606266",
                              },
                            },
                            [_vm._v(_vm._s(_vm.exam.gradeName))]
                          ),
                        ]),
                      ]
                    ),
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c(
                        "p",
                        {
                          staticClass: "download",
                          on: { click: _vm.downloadExe },
                        },
                        [
                          _vm._v(" 下载客户端 "),
                          _c("img", {
                            attrs: {
                              src: require("@/v3/modules/card_use/assets/images/download-icon.png"),
                              width: "16px",
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]),
              _c("router-view", {
                attrs: {
                  "exam-info": _vm.exam,
                  schoolId: _vm.schoolId,
                  resultId: _vm.resultId,
                  isRegion: _vm.isRegion,
                  "login-platform": _vm.loginPlatform,
                },
                on: {
                  changeMenu: _vm.changeMenu,
                  "update:schoolId": function ($event) {
                    _vm.schoolId = $event
                  },
                  "update:school-id": function ($event) {
                    _vm.schoolId = $event
                  },
                  refreshDoubt: _vm.getExamDoubt,
                  changeSchool: _vm.changeSchool,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("footer-bar"),
      _c(
        "yue-dialog",
        {
          attrs: {
            title: "导入学生成绩",
            width: "500px",
            visible: _vm.importVisible,
            center: "",
            "custom-class": "import-grades",
          },
          on: {
            "update:visible": function ($event) {
              _vm.importVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "dialog-content" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.submitLoading,
                    expression: "submitLoading",
                  },
                ],
              },
              [
                _c(
                  "el-upload",
                  {
                    ref: "importUpload",
                    attrs: {
                      limit: 1,
                      accept: ".xlsx,.xls",
                      action: _vm.getUploadUrl(),
                      data: _vm.uploadData,
                      headers: _vm.headers,
                      "on-error": _vm.handleUploadError,
                      "on-success": _vm.handleUploadSuccess,
                      "on-change": _vm.handleUploadChange,
                      "on-remove": _vm.handleUploadChange,
                      "auto-upload": false,
                      "file-list": _vm.importFileList,
                      multiple: false,
                    },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "import-button",
                        attrs: {
                          type: "primary",
                          size: "small",
                          disabled: !_vm.isPermission,
                        },
                      },
                      [
                        _c("img", {
                          attrs: { src: require("images/upLoad.svg") },
                        }),
                        _vm._v(" 导入学生成绩"),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.pageLoading,
                    expression: "pageLoading",
                  },
                ],
              },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-top": "16px" },
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.downloadStudentScoreTemp()
                      },
                    },
                  },
                  [_vm._v("学生成绩模板下载")]
                ),
              ],
              1
            ),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm.ifImportError
                ? _c(
                    "el-button",
                    {
                      staticClass: "import-btn",
                      attrs: { type: "danger", size: "medium" },
                      on: { click: _vm.downloadImportError },
                    },
                    [_vm._v("下载错误信息")]
                  )
                : _c(
                    "el-button",
                    {
                      staticClass: "upload-button",
                      attrs: { loading: _vm.submitLoading },
                      on: {
                        click: function ($event) {
                          return _vm.handleSaveMarkStudent()
                        },
                      },
                    },
                    [_vm._v("确定上传")]
                  ),
            ],
            1
          ),
        ]
      ),
      _c(
        "yue-dialog",
        {
          attrs: {
            title: "编辑记录",
            visible: _vm.logVisible,
            center: "",
            width: "758px",
            "custom-class": "edit-log",
          },
          on: {
            "update:visible": function ($event) {
              _vm.logVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.logLoading,
                  expression: "logLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.logList,
                "header-row-class-name": "header-log",
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "studName", align: "center", label: "姓名" },
              }),
              _c("el-table-column", {
                attrs: { prop: "studNo", align: "center", label: "考号" },
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "题号" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("standardQuestionNumber")(scope.row)
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "teacherName",
                  align: "center",
                  label: "修改人",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "before", align: "center", label: "修改前" },
              }),
              _c("el-table-column", {
                attrs: { prop: "after", align: "center", label: "修改后" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "data",
                  align: "center",
                  label: "修改时间",
                  width: "130px",
                },
              }),
            ],
            1
          ),
          _vm.logPagination.total > 0
            ? _c(
                "div",
                { staticStyle: { height: "50px", "padding-top": "10px" } },
                [
                  _c("zj-pagination", {
                    attrs: {
                      page: { total: _vm.logPagination.total, current: 1 },
                    },
                    on: { "current-change": _vm.handleLogCurrentChange },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "yue-dialog",
        {
          attrs: {
            title: "导出客观题分析",
            visible: _vm.problemAnalysisVisible,
            center: "",
            width: "700px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.problemAnalysisVisible = $event
            },
          },
        },
        [
          _vm.problemAnalysisVisible
            ? _c("export", {
                attrs: {
                  schoolId: _vm.schoolId,
                  examId: _vm.examId,
                  "type-list": [
                    "TEACH_CLASS_OBJECTIVE_STATISTICS",
                    "CLASS_OBJECTIVE_STATISTICS",
                    "SCHOOL_OBJECTIVE_SCORE_DETAIL",
                  ],
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }